import { Box, useStyleConfig } from "@chakra-ui/react";

const CardBody = (props: any) => {
	const { variant, children, ...rest } = props;
	const styles = useStyleConfig("CardBody", { variant });

	return (
		<Box __css={styles} {...rest}>
			{children}
		</Box>
	);
}

export default CardBody;
